module.exports = __webpack_public_path__ + "img/17a002-18.18bc982c.jpg";